import * as React from "react"
import { Slot } from "@radix-ui/react-slot"
import { cva } from "class-variance-authority";
import { cn } from "@/lib/utils"; // Сохраняем ваш системный алиас путей

const buttonVariants = cva(
  // ИСПРАВЛЕНО: Заменили 'whitespace-nowrap' на 'whitespace-normal text-center break-words'
  // ИСПРАВЛЕНО: Сменили скругления 'rounded-md' на премиальные строгие углы 'rounded-none'
  "inline-flex items-center justify-center gap-2 text-center whitespace-normal break-words rounded-none font-medium transition-colors focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring disabled:pointer-events-none disabled:opacity-50 [&_svg]:pointer-events-none [&_svg]:size-4 [&_svg]:shrink-0",
  {
    variants: {
      variant: {
        default:
          "bg-primary text-primary-foreground shadow hover:bg-primary/90",
        destructive:
          "bg-destructive text-destructive-foreground shadow-sm hover:bg-destructive/90",
        outline:
          "border border-input shadow-sm hover:bg-accent hover:text-accent-foreground",
        secondary:
          "bg-secondary text-secondary-foreground shadow-sm hover:bg-secondary/80",
        ghost: "hover:bg-accent hover:text-accent-foreground",
        link: "text-primary underline-offset-4 hover:underline",
      },
      size: {
        // ИСПРАВЛЕНО: Перевели фиксированную высоту в минимальную 'min-h-*' и добавили h-auto + py
        // ИСПРАВЛЕНО: Оптимизировали размеры шрифтов для мобильных (text-[11px] на смартфонах)
        default: "min-h-11 h-auto py-2.5 px-4 sm:px-6 text-[11px] sm:text-xs tracking-wider uppercase",
        sm: "min-h-8 h-auto py-1.5 px-3 text-[10px] tracking-wide uppercase",
        lg: "min-h-12 h-auto py-3 px-8 text-xs sm:text-sm tracking-widest uppercase",
        icon: "h-9 w-9 shrink-0 flex-shrink-0", // Иконки оставляем строго квадратными
      },
    },
    defaultVariants: {
      variant: "default",
      size: "default",
    },
  }
)

const Button = React.forwardRef(({ className, variant, size, asChild = false, ...props }, ref) => {
  const Comp = asChild ? Slot : "button"
  return (
    <Comp
      className={cn(buttonVariants({ variant, size, className }))}
      ref={ref}
      {...props} />
  );
})
Button.displayName = "Button"

export { Button, buttonVariants }
